import { gql } from "@apollo/client";
export const MESSAGE_NOTIFICATION_DISPATCH_SUBSCRIPTION = gql`
  subscription MessageNotificationDispatch($companyId: ID) {
    messageNotificationDispatch(company_id: $companyId) {
      totalUnreadCount
      message
      message_type
      channel_id
      driver {
        id
        first_name
        last_name
        profile_picture
      }
    }
  }
`;